import React from 'react';
import noop from 'lodash/noop';
import { Theme } from '@mui/material';
import { useContent, useContentContext } from '@qbe/dfc-content';
import EmailIcon from '@mui/icons-material/Email';
import PlaceIcon from '@mui/icons-material/Place';
import PhoneIcon from '@mui/icons-material/Phone';

import RadioGroup from 'components/RadioGroup/RadioGroup';
import styled from '@emotion/styled';

interface Props {
  active: string | null;
  onChange?: (value: string, fields: string[]) => void;
  title: string;
  name: string;
  titlePrefix?: React.ReactNode;
  titleSuffix?: React.ReactNode;
}

const StyledRadioGroupNewTiled = styled(RadioGroup)`
  .MuiFormControlLabel-root {
    ${({ theme }) => `${(theme as Theme).breakpoints.down('md')} {
      width: 80px !important;
    }`}
  }
`;

const ContactPreferredMethod = ({ active = null, name, onChange = noop, title, titleSuffix, titlePrefix }: Props) => {
  const { getTextContent } = useContent({ context: useContentContext() });
  // Localized content constants
  const emailLabel = getTextContent('contactPreferred.email');
  const postLabel = getTextContent('contactPreferred.post');
  const phoneLabel = getTextContent('contactPreferred.phone');
  return (
    <StyledRadioGroupNewTiled
      required
      title={title}
      titlePrefix={titlePrefix}
      titleSuffix={titleSuffix}
      name={name}
      styleVariant="tile"
      tileWidth="100px"
      onChange={(value) => {
        onChange(value, ['email', 'post', 'phone']);
      }}
      radioList={
        [
          {
            iconProps: { muiIcon: EmailIcon, color: 'gray', size: 48 },
            id: `${name}_email`,
            label: emailLabel,
            value: 'email',
            'data-track': 'email',
            'data-track-value': 'capture',
          },
          {
            iconProps: { muiIcon: PlaceIcon, color: 'gray', size: 48 },
            id: `${name}_post`,
            label: postLabel,
            value: 'post',
            'data-track': 'post',
            'data-track-value': 'capture',
          },
          {
            iconProps: { muiIcon: PhoneIcon, color: 'gray', size: 48 },
            id: `${name}_phone`,
            label: phoneLabel,
            value: 'phone',
            'data-track': 'phone',
            'data-track-value': 'capture',
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ] as any
      }
    />
  );
};

export default ContactPreferredMethod;
